module.exports = {
	path:      '/messages',
	component: require('@views/Messages').default,
	meta:      {
		title:   'Messages',
		icon:    ['far', 'envelope'],
		primary: true,
		extra:   {
			type:   'Badge',
			name:   'messages/messages',
			params: ['unread', false, 5]
		},
		search:  {
			placeholder: 'Search Messages',
			show:        true
		}
	}
};